/*
 * Lichcards — mobiel, ronde 21-09-2026 (verbeterlijst mobiel, punten 1, 3, 5, 7).
 * Laadt op elke pagina via snippets/lichcards-design.liquid, uitgesteld.
 *
 *  1. Voorraadkleur bij variantwissel: het thema ververst alleen de TEKST van
 *     <product-inventory>, niet de statusklasse. Dit script zet zelf
 *     lc-inv-low / lc-inv-out op het element (CSS kleurt oranje/rood).
 *  2. Taalnaam in het kopje van de kiezer ("Taal: Engels") vertaald houden na
 *     een variantwissel.
 *  7. Kortingspercentage ("−20%") naast de doorgestreepte prijs, ook na een
 *     variantwissel (het thema rendert de prijs dan opnieuw).
 *  3. Op mobiel (< 750 px) en in het Nederlands: "Toevoegen aan winkelwagen"
 *     → "In winkelwagen" op de koopknop en in de sticky balk, zodat de knop
 *     op één regel past. "Uitverkocht" en "Pre-order" blijven staan.
 *  5. De utility-balk staat op mobiel uit (CSS); de drie rechterlinks
 *     (Verkoop je kaarten / Spaarpunten / Contact) komen dan onderaan in het
 *     uitklapmenu (de knop met drie streepjes), voor zover ze daar nog niet
 *     in staan — "Kaarten verkopen" staat er al als gewoon menu-item.
 */
(function () {
  'use strict';

  var LANG = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  if (!/^(nl|en|de|fr|es|it)$/.test(LANG)) LANG = 'nl';
  var MQ_MOBILE = '(max-width: 749px)';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function isMobile() {
    return window.matchMedia(MQ_MOBILE).matches;
  }

  function lcPath(path) {
    return ROOT.replace(/\/$/, '') + path;
  }

  /* ---------- 1. voorraadstatus ---------- */

  function classifyInventory(el) {
    var textEl = el.querySelector('.product-inventory__text');
    var text = ((textEl ? textEl.textContent : el.textContent) || '').trim();
    if (!text) return;
    var soldOut = false;
    var price = el.closest('.group-block-content, .product-details');
    if (price && price.querySelector('.price--sold-out')) soldOut = true;
    var submit = document.querySelector('.product-details .product-form__submit');
    if (submit && submit.disabled) soldOut = true;
    var low = !soldOut && /\d/.test(text);
    el.classList.toggle('lc-inv-out', soldOut);
    el.classList.toggle('lc-inv-low', low);
  }

  function watchInventory() {
    var els = document.querySelectorAll('.product-details product-inventory');
    if (!els.length) return;
    Array.prototype.forEach.call(els, function (el) {
      classifyInventory(el);
      new MutationObserver(function () { classifyInventory(el); })
        .observe(el, { childList: true, characterData: true, subtree: true });
    });
    // De prijs (price--sold-out) en de knop (disabled) veranderen na de tekst;
    // nog één keer kijken zodra de variantwissel klaar is.
    document.addEventListener('variant:change', function () {
      setTimeout(function () { Array.prototype.forEach.call(els, classifyInventory); }, 50);
    });
    var form = document.querySelector('.product-details product-form-component, .product-details .product-form');
    if (form) {
      new MutationObserver(function () { Array.prototype.forEach.call(els, classifyInventory); })
        .observe(form, { attributes: true, subtree: true, attributeFilter: ['disabled', 'class'] });
    }
  }

  /* ---------- 2. taalnaam in de kiezer vertaald houden ----------
   * De pillen krijgen hun vertaalde label uit Liquid (snippets/
   * lichcards-variant-label.liquid), maar na een variantwissel zet het thema
   * de RUWE optiewaarde ("English") in het kopje "Taal: …". Hier terugvertaald;
   * de invoerwaarden blijven ongemoeid. */

  var LANG_NAMES = {
    nl: { en: 'Engels', de: 'Duits', fr: 'Frans', it: 'Italiaans', es: 'Spaans', nl: 'Nederlands', ja: 'Japans', ko: 'Koreaans', zh: 'Chinees', pt: 'Portugees', ru: 'Russisch' },
    en: { en: 'English', de: 'German', fr: 'French', it: 'Italian', es: 'Spanish', nl: 'Dutch', ja: 'Japanese', ko: 'Korean', zh: 'Chinese', pt: 'Portuguese', ru: 'Russian' },
    de: { en: 'Englisch', de: 'Deutsch', fr: 'Französisch', it: 'Italienisch', es: 'Spanisch', nl: 'Niederländisch', ja: 'Japanisch', ko: 'Koreanisch', zh: 'Chinesisch', pt: 'Portugiesisch', ru: 'Russisch' },
    fr: { en: 'Anglais', de: 'Allemand', fr: 'Français', it: 'Italien', es: 'Espagnol', nl: 'Néerlandais', ja: 'Japonais', ko: 'Coréen', zh: 'Chinois', pt: 'Portugais', ru: 'Russe' },
    es: { en: 'Inglés', de: 'Alemán', fr: 'Francés', it: 'Italiano', es: 'Español', nl: 'Neerlandés', ja: 'Japonés', ko: 'Coreano', zh: 'Chino', pt: 'Portugués', ru: 'Ruso' },
    it: { en: 'Inglese', de: 'Tedesco', fr: 'Francese', it: 'Italiano', es: 'Spagnolo', nl: 'Olandese', ja: 'Giapponese', ko: 'Coreano', zh: 'Cinese', pt: 'Portoghese', ru: 'Russo' }
  };
  var LANG_KEYS = {
    english: 'en', engels: 'en', german: 'de', duits: 'de', deutsch: 'de', french: 'fr', frans: 'fr',
    italian: 'it', italiaans: 'it', spanish: 'es', spaans: 'es', dutch: 'nl', nederlands: 'nl',
    japanese: 'ja', japans: 'ja', japanspokemon: 'ja', korean: 'ko', koreaans: 'ko', chinese: 'zh', chinees: 'zh',
    portuguese: 'pt', portugees: 'pt', russian: 'ru', russisch: 'ru'
  };

  function translateLangLabel(el) {
    var raw = (el.textContent || '').trim();
    var id = LANG_KEYS[raw.toLowerCase()];
    if (!id) return;
    var name = LANG_NAMES[LANG][id];
    if (name && name !== raw) el.textContent = name;
  }

  function watchLangLabel() {
    var els = document.querySelectorAll('.product-details variant-selects .variant-option--language [data-selected-value], .product-details variant-selects .variant-option--taal [data-selected-value]');
    if (!els.length) return;
    Array.prototype.forEach.call(els, function (el) {
      translateLangLabel(el);
      var busy = false;
      new MutationObserver(function () {
        if (busy) return;
        busy = true;
        setTimeout(function () { busy = false; translateLangLabel(el); }, 10);
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- 7. kortingspercentage naast de prijs ---------- */

  function parseMoney(text) {
    // "€71,95", "€1.234,50", "€0.21 EUR" → getal in centen-precisie (float)
    var s = String(text || '').replace(/[^\d.,]/g, '');
    if (!s) return NaN;
    var lastComma = s.lastIndexOf(','), lastDot = s.lastIndexOf('.');
    if (lastComma > lastDot) s = s.replace(/\./g, '').replace(',', '.');
    else s = s.replace(/,/g, '');
    return parseFloat(s);
  }

  function updateSaveBadge(priceEl) {
    var container = priceEl.querySelector('.price-product-container');
    if (!container) return;
    var badge = container.querySelector('.lc-save');
    var sale = container.querySelector('.price-item--sale');
    var regular = container.querySelector('.compare-at-price');
    var onSale = container.classList.contains('price--on-sale') && sale && regular;
    var pct = 0;
    if (onSale) {
      var a = parseMoney(sale.textContent), b = parseMoney(regular.textContent);
      if (a > 0 && b > a) pct = Math.round((1 - a / b) * 100);
    }
    if (pct < 5) { if (badge) badge.remove(); return; }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'lc-save';
      badge.setAttribute('aria-hidden', 'true');
      container.appendChild(badge);
    }
    badge.textContent = '−' + pct + '%';
  }

  function watchPrice() {
    var els = document.querySelectorAll('.product-details product-price');
    if (!els.length) return;
    Array.prototype.forEach.call(els, function (el) {
      updateSaveBadge(el);
      var busy = false;
      new MutationObserver(function (records) {
        // eigen badge-mutaties negeren
        if (busy) return;
        if (records.every(function (r) { return r.target.closest && r.target.closest('.lc-save'); })) return;
        busy = true;
        setTimeout(function () { busy = false; updateSaveBadge(el); }, 20);
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- 3. korte knoptekst op mobiel (NL) ---------- */

  var LONG_NL = 'Toevoegen aan winkelwagen';
  var SHORT_NL = 'In winkelwagen';

  function shortenButtonText() {
    if (LANG !== 'nl') return;
    var targets = document.querySelectorAll(
      '.product-details .add-to-cart-button .add-to-cart-text__content, ' +
      '.product-details .add-to-cart-button .add-to-cart-text, ' +
      '.sticky-atc .product-form__submit .add-to-cart-text'
    );
    var mobile = isMobile();
    Array.prototype.forEach.call(targets, function (el) {
      if (el.children.length) return; // alleen het blaadje met de tekst zelf
      var t = (el.textContent || '').trim();
      if (mobile && t === LONG_NL) {
        el.textContent = SHORT_NL;
        el.setAttribute('data-lc-short', '1');
      } else if (!mobile && t === SHORT_NL && el.getAttribute('data-lc-short')) {
        el.textContent = LONG_NL;
        el.removeAttribute('data-lc-short');
      }
    });
  }

  function watchButtonText() {
    if (LANG !== 'nl') return;
    if (!document.querySelector('.product-details .add-to-cart-button, .sticky-atc')) return;
    shortenButtonText();
    var scope = document.querySelector('#MainContent') || document.body;
    var busy = false;
    new MutationObserver(function () {
      if (busy) return;
      busy = true;
      setTimeout(function () { busy = false; shortenButtonText(); }, 30);
    }).observe(scope, { childList: true, characterData: true, subtree: true });
    window.matchMedia(MQ_MOBILE).addEventListener('change', shortenButtonText);
  }

  /* ---------- 5. utility-links in het hamburgermenu ---------- */

  var MENU_I18N = {
    nl: { sell: 'Verkoop je kaarten', loyalty: 'Spaarpunten', contact: 'Contact' },
    en: { sell: 'Sell your cards', loyalty: 'Loyalty points', contact: 'Contact' },
    de: { sell: 'Karten verkaufen', loyalty: 'Treuepunkte', contact: 'Kontakt' },
    fr: { sell: 'Vendre vos cartes', loyalty: 'Points fidélité', contact: 'Contact' },
    es: { sell: 'Vende tus cartas', loyalty: 'Puntos', contact: 'Contacto' },
    it: { sell: 'Vendi le tue carte', loyalty: 'Punti fedeltà', contact: 'Contatti' }
  };

  var drawerMenu = null;
  var drawerMenuSelector = '.menu-drawer__navigation > .menu-drawer__menu';

  function addDrawerLinks(candidate) {
    if (candidate instanceof Element && candidate.matches(drawerMenuSelector)) drawerMenu = candidate;
    if (!isMobile()) return;
    var nav = drawerMenu?.isConnected ? drawerMenu : document.querySelector(drawerMenuSelector);
    drawerMenu = nav;
    if (!nav || nav.dataset.lcUtility) return;
    nav.dataset.lcUtility = '1';
    var t = MENU_I18N[LANG];
    var items = [
      { text: t.sell, href: lcPath('/pages/pokemon-kaarten-verkopen') },
      { text: t.loyalty, href: lcPath('/pages/spaarpunten') },
      { text: t.contact, href: lcPath('/pages/contact') }
    ];
    // Staat een link al zichtbaar in het menu (bv. het thema-item "Kaarten
    // verkopen"), dan komt hij hier niet nog eens bij. De href van het thema
    // heeft soms witruimte eromheen, vandaar trim().
    function norm(h) { return (h || '').trim().replace(/\/$/, ''); }
    items.forEach(function (it) {
      var href = norm(it.href);
      var visiblePresent = false;
      Array.prototype.forEach.call(nav.querySelectorAll('a'), function (a) {
        if (norm(a.getAttribute('href')) !== href) return;
        if (a.closest('.lc-drawer-extra')) return;
        var wrap = a.closest('li') || a.closest('menu-drawer') || a;
        if (a.dataset.lcHidden || wrap.dataset.lcHidden) return;
        if (a.style.display === 'none' || wrap.style.display === 'none') return;
        visiblePresent = true;
      });
      if (visiblePresent) return;
      var el = document.createElement('li');
      el.className = 'menu-drawer__list-item lc-drawer-extra';
      var a = document.createElement('a');
      a.href = it.href;
      a.className = 'menu-drawer__menu-item list-menu__item link link--text focus-inset';
      a.textContent = it.text;
      el.appendChild(a);
      nav.appendChild(el);
    });
  }

  function watchDrawer() {
    addDrawerLinks();
    new MutationObserver(function (records) {
      var replacement = null;
      records.some(function (record) {
        return Array.prototype.some.call(record.addedNodes, function (node) {
          if (!(node instanceof Element) || !node.isConnected || node.matches('script, style, link, svg, .lc-fx-burst')) return false;
          replacement = node.matches(drawerMenuSelector) ? node :
            node.firstElementChild ? node.querySelector(drawerMenuSelector) : null;
          return !!replacement;
        });
      });
      if (replacement) addDrawerLinks(replacement);
      else if (drawerMenu && !drawerMenu.isConnected) drawerMenu = null;
    }).observe(document.body, { childList: true, subtree: true });
    window.matchMedia(MQ_MOBILE).addEventListener('change', function () { addDrawerLinks(); });
    document.addEventListener('shopify:section:load', function () { addDrawerLinks(); });
  }

  function init() {
    try { watchInventory(); } catch (e) { /* stil */ }
    try { watchLangLabel(); } catch (e) { /* stil */ }
    try { watchPrice(); } catch (e) { /* stil */ }
    try { watchButtonText(); } catch (e) { /* stil */ }
    try { watchDrawer(); } catch (e) { /* stil */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
